import { useState, useEffect } from "react";
// import Loader from "../../utils/Loader";
import { inventory } from "./transactions";
// import { sendRequest } from "../../utils/useAxios";
// import { connection } from "../../utils/apiConnection.ts";
import useAxios from "../../../services/useAxios.tsx";

function UserName({ id, Updater }) {
  const { execute: findUsers } = useAxios("api/Find_users");
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [Inventory, setInventory] = useState("");
  console.log(Updater, "this");
  useEffect(() => {
    async function fetchData(params) {
      if (!isNaN(parseInt(id))) {
        setLoading(true);
        let money = await inventory(id);
        setInventory(money);
        // let form = new FormData();
        // form.append();
        // connection("api/Find_users", {
        findUsers({
          conditions: `users.id/=/${id}`,
          tbl_name: "left join,files,profile_pic_file_id,id",
        })
          .then((data) => {
            setLoading(false);
            setInfo(data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    fetchData();
  }, [Updater]);

  return (
    <div className="modal fade" id="userInfo" tabIndex={-1} aria-hidden="true">
      {/* {loading ? <Loader /> : ""} */}

      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">اطلاعات کاربر</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {info && (
              <>
                {info.path && (
                  <img
                    className="rounded-circle m-2"
                    style={{ width: "100px", height: "100px" }}
                    src={`${"https://sabadi.ir/api/" + info.path}`}
                  />
                )}
                <h5>نام و نام خانوادگی :{info.fullname}</h5>
                {/* <h5>نام پدر :{info.fathername}</h5> */}
                <h5>کد ملی :{info.codemeli}</h5>
                <h5>شماره تماس :{info.mobile}</h5>
                <h5> موجودی کیف پول :{Inventory}</h5>
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserName;
